import styled from 'styled-components';

export const SeeEligiblePackagesModalContentList = styled('ul')`
  margin-bottom: 0;
  padding-left: 1.8rem;

  .ant-tag {
    margin-left: 0.5rem;
  }
`;
